import React, { Component } from 'react';
import { get } from 'lodash';
import styled from 'styled-components';
import Select, { components } from 'react-select';

const FlexWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
`;

const LogoImg = styled.img`
    height: 20px;
    width: 20px;
    margin-right: 5px;
`;

const TextWrapper = styled.span`
    height: 20px;
`;

const Option = props => (
    <components.Option {...props}>
        <FlexWrapper>
            <LogoImg id='AppIcon' src={props.data.image.src} />
            <span>{props.data.text}</span>
        </FlexWrapper>
    </components.Option>
);

const ValueContainer = ({ children, ...props }) => {
    const logo = get(props.getValue(), '[0].image.src', null);
    return (
        components.ValueContainer && (
            <components.ValueContainer {...props}>
                <FlexWrapper>
                    {logo && <LogoImg src={logo}/> }
                    <TextWrapper>{get(props.getValue(), '[0].text', null)}</TextWrapper>
                </FlexWrapper>
                {children}
            </components.ValueContainer>
        ));
};

class DropdownSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: get(props, 'input.value', '')
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const nextInputValue = nextProps.input.value;

        let nextState = null;
        if (nextInputValue !== prevState.value) {
            nextState = {
                value: nextInputValue
            };
        }

        return nextState;
    }

    static controlStyles(styles) {
        return {
            ...styles,
            width: '200px'
        };
    }

    static optionStyles(styles) {
        return {
            ...styles,
            backgroundColor: '#fff', // eslint-disable-line no-nested-ternary
            textAlign: 'center',
            margin: 0,
            border: '1px solid #fff',
            color: '#999',
            boxSizing: 'borderBox',
            '&:active': {
                backgroundColor: '#fff'
            },
            ':hover': {
                backgroundColor: '#ebf4f8',
            },
        };
    }

    static valueContainerStyles(styles) {
        return {
            ...styles,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            overflow: 'hidden',
            color: '#999',
            width: '200px',

            input: {
                position: 'absolute'
            }
        };
    }

    static customStyles() {
        return {
            option: DropdownSelect.optionStyles,
            valueContainer: DropdownSelect.valueContainerStyles,
            controlStyles: DropdownSelect.controlStyles
        };
    }

    navChange = (option, input) => {
        input.onChange(option.value);
        this.setState({
            value: option.value
        });
    };

    render() {
        const { list = {}, input } = this.props;
        const inputValue = this.state.value;
        const listArray = Object.values(list);

        return (
            <Select
                options={listArray}
                value={list[inputValue]}
                onChange={option => this.navChange(option, input)}
                styles={DropdownSelect.customStyles()}
                isSearchable={false}
                components={{ Option, ValueContainer }}
            />
        );
    }
}

export default DropdownSelect;



// WEBPACK FOOTER //
// ./src/components/atoms/inputs/DropdownSelect.js